class ProductGallery {
  constructor(container) {
    this.container = container;
    this.slidesContainer = container.querySelector('.gallery-slides');
    this.slides = this.slidesContainer.querySelectorAll('.gallery-cell');
    this.currentIndex = 0;
    this.dotsContainer = container.querySelector('.gallery-dots');
    this.prevButton = container.querySelector('.gallery-prev');
    this.nextButton = container.querySelector('.gallery-next');
    this.touchStartX = null;
    this.touchEndX = null;
    this.isMobile = window.innerWidth < 768;
    this.isSwipingGallery = false;

    if (this.slides.length > 1) {
      this.init();
    }
  }

  init() {
    this.setupDots();
    this.bindEvents();
    this.showSlide(0);
  }

  setupDots() {
    if (!this.dotsContainer) return;
    
    // Add data-index attributes to dots if they don't have them
    const dots = this.dotsContainer.querySelectorAll('.gallery-dot');
    dots.forEach((dot, index) => {
      if (!dot.hasAttribute('data-index')) {
        dot.setAttribute('data-index', index);
      }
      dot.addEventListener('click', () => this.showSlide(index));
    });
  }

  bindEvents() {
    // Bind arrow events
    if (this.prevButton) {
      this.prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.prevSlide();
      });
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.nextSlide();
      });
    }

    // Bind touch events
    this.bindTouchEvents();

    // Handle window resize
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 768;
    });
  }

  bindTouchEvents() {
    this.touchStartY = null;
    this.isHorizontalSwipe = false;
    
    this.container.addEventListener('touchstart', (e) => {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.isSwipingGallery = true;
      this.isHorizontalSwipe = false;
    }, { passive: true });

    this.container.addEventListener('touchmove', (e) => {
      if (!this.isSwipingGallery) return;
      
      this.touchEndX = e.touches[0].clientX;
      const touchEndY = e.touches[0].clientY;
      
      // Calculate movement
      const deltaX = Math.abs(this.touchStartX - this.touchEndX);
      const deltaY = Math.abs(this.touchStartY - touchEndY);
      
      // Only treat as horizontal swipe if horizontal movement is significantly greater than vertical
      if (deltaX > 20 && deltaX > deltaY * 1.5) {
        this.isHorizontalSwipe = true;
        e.preventDefault(); // Only prevent default for clear horizontal swipes
        
        // Prevent parent carousel scroll for horizontal swipes
        const carousel = this.container.closest('.products-slider');
        if (carousel) {
          carousel.style.overflow = 'hidden';
        }
      }
    }, { passive: false });

    this.container.addEventListener('touchend', () => {
      if (this.isSwipingGallery && this.isHorizontalSwipe && this.touchStartX !== null && this.touchEndX !== null) {
        const diff = this.touchStartX - this.touchEndX;
        if (Math.abs(diff) > 30) {
          if (diff > 0) {
            this.nextSlide();
          } else {
            this.prevSlide();
          }
        }
      }
      
      // Reset touch tracking
      this.touchStartX = null;
      this.touchStartY = null;
      this.touchEndX = null;
      this.isSwipingGallery = false;
      this.isHorizontalSwipe = false;
      
      // Re-enable parent carousel scroll
      const carousel = this.container.closest('.products-slider');
      if (carousel) {
        carousel.style.overflow = 'auto';
      }
    }, { passive: true });
  }

  showSlide(index) {
    // Update slides
    this.slides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add('is-selected');
      } else {
        slide.classList.remove('is-selected');
      }
    });

    // Update dots
    if (this.dotsContainer) {
      const dots = this.dotsContainer.querySelectorAll('.gallery-dot');
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('is-selected');
        } else {
          dot.classList.remove('is-selected');
        }
      });
    }

    this.currentIndex = index;
  }

  nextSlide() {
    const newIndex = (this.currentIndex + 1) % this.slides.length;
    this.showSlide(newIndex);
  }

  prevSlide() {
    const newIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.showSlide(newIndex);
  }
}

// Helper function to truncate description if too long
function truncateDescription(description, maxLength = 300) {
  if (!description) return '';
  if (description.length <= maxLength) return description;
  
  // Find the last space before maxLength to avoid cutting words
  const lastSpace = description.substring(0, maxLength).lastIndexOf(' ');
  return description.substring(0, lastSpace) + '...';
}

// DEBUG: Monitor working product card forms
function debugWorkingForms() {
  const workingForms = document.querySelectorAll('product-form form');
  workingForms.forEach((form, index) => {
    if (!form.hasAttribute('data-debug-added')) {
      form.setAttribute('data-debug-added', 'true');
      form.addEventListener('submit', function(e) {
        console.log(`✅ WORKING FORM ${index + 1} SUBMIT:`);
        const formData = new FormData(form);
        console.log('- Form Action:', form.action);
        console.log('- Form Method:', form.method);
        console.log('- Form Data:');
        for (let [key, value] of formData.entries()) {
          console.log(`  - ${key}: ${value}`);
        }
      });
    }
  });
}

// Quick View implementation
function initQuickView() {
  const quickViewButtons = document.querySelectorAll('.quick-view-button');
  if (!quickViewButtons.length) return;
  
  // Add debug monitoring for working forms
  debugWorkingForms();
  
  // Check if modal exists, if not create it
  let modal = document.getElementById('quick-view-modal');
  if (!modal) {
    modal = createQuickViewModal();
  }
  
  const modalContent = modal.querySelector('.quick-view-body');
  const closeButton = modal.querySelector('.quick-view-close');
  const overlay = modal.querySelector('.quick-view-overlay');
  
  // Open modal
  quickViewButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = button.getAttribute('data-variant-id');
      const productHandle = button.getAttribute('data-product-handle') || '';
      
      console.log('🔍 QUICKVIEW DEBUG:');
      console.log('- Variant ID:', variantId);
      console.log('- Product Handle:', productHandle);
      
      // Show modal
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      
      // Load product data
      modalContent.innerHTML = `
        <div class="quick-view-loading">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      `;
      
      // Get product data
      const productCard = button.closest('.product-card');
      const productTitle = productCard.querySelector('.product-card__title').textContent.trim();
      const productImage = productCard.querySelector('.product-card__image').cloneNode(true);
      const productPrice = productCard.querySelector('.price--enhanced').innerHTML;
      const productDescription = productCard.getAttribute('data-product-description') || '';
      
      // Get stock badges if they exist
      const stockBadge = productCard.querySelector('.badge--stock-level');
      const inStockBadge = productCard.querySelector('.badge--in-stock');
      let stockBadgeHTML = '';
      
      if (stockBadge) {
        stockBadgeHTML = `<div class="quick-view-stock-alert badge--stock-level">${stockBadge.textContent}</div>`;
      } else if (inStockBadge) {
        stockBadgeHTML = `<div class="quick-view-stock-alert badge--in-stock">${inStockBadge.textContent}</div>`;
      }
      
      // Create description HTML only if description exists
      const truncatedDescription = truncateDescription(productDescription);
      const descriptionHTML = truncatedDescription ?
        `<div class="quick-view-product-description">
          <p>${truncatedDescription}</p>
        </div>` : '';
        
      // Create urgency/sales optimization elements  
      const limitedStockText = (window.themeSettings && window.themeSettings.quickview && window.themeSettings.quickview.limitedStockText) || '⚡ Limited Stock - Order Now!';
      const urgencyHTML = stockBadge ? 
        `<div class="quick-view-urgency">
          <p class="urgency-text">${limitedStockText}</p>
        </div>` : '';
      
      // Build modal content with proper timeout to allow loading state
      setTimeout(() => {
        modalContent.innerHTML = `
          <div class="quick-view-product">
            <h2 id="quick-view-title" class="quick-view-product-title">${productTitle}</h2>
            <div class="quick-view-product-content">
              <div class="quick-view-product-image">
                ${productImage.outerHTML}
              </div>
              <div class="quick-view-product-details">
                <div class="quick-view-product-price">${productPrice}</div>
                ${stockBadgeHTML}
                ${urgencyHTML}
                ${descriptionHTML}
                <product-form class="product-form" data-section="product-card">
                  <form method="post" action="/cart/add" class="product-form__form">
                    <input type="hidden" name="id" value="${variantId}">
                    <div class="product-form__error-message-wrapper" role="alert" hidden>
                      <span class="product-form__error-message"></span>
                    </div>
                    <button type="submit" name="add" class="quick-view-add-to-cart" aria-label="Add to cart">
                      ${(window.themeSettings && window.themeSettings.quickview && window.themeSettings.quickview.addToCartText) || '🛒 Add to cart'}
                      <div class="loading-overlay__spinner hidden">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </button>
                  </form>
                </product-form>
                <a href="/products/${productHandle || 'product'}" class="quick-view-full-details">${(window.themeSettings && window.themeSettings.quickview && window.themeSettings.quickview.viewDetailsText) || '👁️ View full details'}</a>
              </div>
            </div>
          </div>
        `;
        
        // Add instant auto-close functionality
        const quickViewForm = modalContent.querySelector('product-form form');
        
        if (quickViewForm) {
          console.log('🚀 QUICKVIEW: Setting up instant auto-close functionality');
          
          // Close modal immediately when form is submitted
          quickViewForm.addEventListener('submit', function(e) {
            console.log('🚀 QUICKVIEW FORM SUBMIT - Closing modal instantly');
            
            // Close modal immediately with a very short delay to ensure submission goes through
            setTimeout(() => {
              closeModal();
            }, 100); // Minimal delay to ensure form submission is processed
          });
        }
        
        // DEBUG: Monitor for any cart errors
        const productForm = modalContent.querySelector('product-form');
        if (productForm) {
          console.log('✅ Product form element found, monitoring for errors...');
          const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
          if (errorWrapper) {
            const observer = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                if (!errorWrapper.hidden) {
                  const errorMsg = errorWrapper.querySelector('.product-form__error-message');
                  console.log('❌ QUICKVIEW ERROR DETECTED:', errorMsg ? errorMsg.textContent : 'Unknown error');
                }
              });
            });
            observer.observe(errorWrapper, { attributes: true, attributeFilter: ['hidden'] });
          }
        }
      }, 500);
    });
  });
  
  // Close modal
  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  
  closeButton.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
  
  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });
}

// Create Quick View Modal if it doesn't exist
function createQuickViewModal() {
  const modal = document.createElement('div');
  modal.id = 'quick-view-modal';
  modal.className = 'quick-view-modal';
  modal.setAttribute('aria-hidden', 'true');
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-labelledby', 'quick-view-title');
  
  modal.innerHTML = `
    <div class="quick-view-overlay"></div>
    <div class="quick-view-content">
      <button type="button" class="quick-view-close" aria-label="Close quick view">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <div class="quick-view-body">
        <!-- Content will be loaded via AJAX -->
      </div>
    </div>
  `;
  
  document.body.appendChild(modal);
  return modal;
}

// Lazy loading implementation
function initLazyLoading() {
  const images = document.querySelectorAll('.product-card__image');
  
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const image = entry.target;
          const src = image.getAttribute('data-src');
          const srcset = image.getAttribute('data-srcset');
          
          if (src) image.src = src;
          if (srcset) image.srcset = srcset;
          
          image.classList.add('lazyloaded');
          image.classList.remove('lazyloading');
          
          observer.unobserve(image);
        }
      });
    });
    
    images.forEach(image => {
      // Only observe images with data-src attribute
      if (image.hasAttribute('data-src')) {
        image.classList.add('lazyloading');
        imageObserver.observe(image);
      }
    });
  } else {
    // Fallback for browsers that don't support IntersectionObserver
    images.forEach(image => {
      if (image.hasAttribute('data-src')) {
        image.src = image.getAttribute('data-src');
        if (image.hasAttribute('data-srcset')) {
          image.srcset = image.getAttribute('data-srcset');
        }
        image.classList.add('lazyloaded');
      }
    });
  }
}

// Keyboard navigation
function initKeyboardNavigation() {
  // Make product cards focusable
  const productLinks = document.querySelectorAll('.product-card__link');
  productLinks.forEach(link => {
    link.setAttribute('tabindex', '0');
    
    // Add keyboard event for Enter key
    link.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.currentTarget.click();
      }
    });
  });
  
  // Make quick view buttons keyboard accessible
  const quickViewButtons = document.querySelectorAll('.quick-view-button');
  quickViewButtons.forEach(button => {
    button.setAttribute('tabindex', '0');
  });
  
  // Make gallery dots keyboard accessible
  const galleryDots = document.querySelectorAll('.gallery-dot');
  galleryDots.forEach(dot => {
    dot.setAttribute('tabindex', '0');
    
    // Add keyboard event for Enter key
    dot.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.currentTarget.click();
      }
    });
  });
  
  // Make gallery navigation buttons keyboard accessible
  const galleryNavButtons = document.querySelectorAll('.gallery-prev, .gallery-next');
  galleryNavButtons.forEach(button => {
    button.setAttribute('tabindex', '0');
  });
}

// Initialize all functionality
function initProductCardGallery() {
  // Initialize product galleries
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    new ProductGallery(gallery);
  });
  
  // Initialize lazy loading
  initLazyLoading();
  
  // Initialize quick view
  initQuickView();
  
  // Add keyboard navigation
  initKeyboardNavigation();
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', initProductCardGallery);

// Handle Shopify section events
document.addEventListener('shopify:section:load', initProductCardGallery); 